import { computed, ref, watch } from 'vue';
import axios from 'axios';
import SelectorComponents from '@/components/stemdo-components/stemdo-components.component.vue';
import { required, email, minLength, maxLength, helpers } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import { useVuelidate } from '@vuelidate/core';
import { useRouter } from '@/plugins/router';

export default {
  mixins: [validationMixin],

  validations: {
    username: {
      required,
      minLength: minLength(5),
      maxLength: maxLength(254),
      email
    }
  },

  components: {
    SelectorComponents
  },
  setup(_, { emit }) {
    const errorMessage = ref(false);
    const v$ = useVuelidate();
    const isFormInvalid = ref<boolean | null>(null);
    const username = ref('');
    const requestOtpMessage = ref(false);
    const isSubmitDisabled = computed(() => !username.value);
    const route = useRouter();

    const emitSms = (payload: { error?: boolean; authenticationError?: boolean }) => {
      emit('sms', payload);
    };

    watch([username], () => {
      isFormInvalid.value = null;
    });

    watch(requestOtpMessage, newValue => {
      if (newValue) {
        username.value = '';
      }
    });

    const validateForm = () => {
      isFormInvalid.value = v$.value.username.$invalid;
      requestOtpMessage.value = false;
      if (!isFormInvalid.value) {
        generateOtpEmail();
      }
    };

    const generateOtpEmail = async (): Promise<void> => {
      const nextUrl = route.currentRoute.query.next || undefined;
      try {
        await axios.post('/api/otps/email', { username: username.value, nextUrl });
        requestOtpMessage.value = true;
        emitSms({ error: false });
      } catch (err) {
        console.error('Error generating and sending the OTP:', err);
        emitSms({ error: true });
        errorMessage.value = true;
        requestOtpMessage.value = false;
      }
    };

    return {
      username,
      isSubmitDisabled,
      isFormInvalid,
      errorMessage,
      requestOtpMessage,
      validateForm
    };
  }
};
